import { render, staticRenderFns } from "./TextureEdit.vue?vue&type=template&id=6575858c&"
import script from "./TextureEdit.vue?vue&type=script&lang=js&"
export * from "./TextureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports